import axios from 'axios';
import React, { createContext, useContext, useEffect, useState } from 'react';

import { AdminDepartmentType, UserRolesType } from '../@types';
import constants from '../constants';
import { connectSocket, socket } from '../socket';
// import requestAPI from '../utils/requestAPI';

export type AuthType = {
  _id: string;
  createdAt?: string;
  role?: UserRolesType;
  avatar?: string;
  name: string;
  fullName: string;
  emailAddress: string;
  title?: string;
  user?: string;
  mobileNumber?: string;
  isOnboardingCompleted: boolean;
  isApproved?:boolean;
  onboardingStep: number;
  hasEmailVerified?: boolean;
  hasPaymentMethod?: boolean;
  hasMobileNumberVerified?: boolean;
  countryCode?: string;
  isBlocked?: boolean;
  certifications?: any[];
  licenses?: any[];
  companyDetails?: {
    companyName?: string;
  };
  contactInfo?: {
    address1?: string;
    address2?: string;
    city?: string;
    country?: string;
    postalCode?: string;
    phoneNumber?: string;
  };
  department: AdminDepartmentType;
} | null;

export const RootContext = createContext<{
  auth: AuthType;
  setAuth: React.Dispatch<React.SetStateAction<AuthType>>;
  clearAuth: () => void;
  updateAuth: (data: AuthType) => void;
}>({
  auth: null,
  setAuth: () => {},
  clearAuth: () => {},
  updateAuth: () => {},
});

type RootProviderProps = {
  children: React.ReactNode;
};
export const RootProvider = ({ children }: RootProviderProps) => {
  const [auth, setAuth] = useState<AuthType>(null);
  const [isReady, setReady] = useState(false);

  const initAuth = async () => {
    const token = localStorage.getItem(constants.LOCAL_STORAGE_KEY.accessKey);
    const userStrings = localStorage.getItem(constants.LOCAL_STORAGE_KEY.user);

    if (token && !socket) {
      connectSocket(token);
    }

    const user = userStrings && JSON.parse(userStrings);
    axios.defaults.headers.Authorization = `Bearer ${token}`;
    setAuth(user);
    setReady(true);
  };

  const updateAuth = (data: AuthType) => {
    const updatedData = { ...auth, ...data } as AuthType;

    setAuth(updatedData);
    localStorage.setItem(
      constants.LOCAL_STORAGE_KEY.user,
      JSON.stringify(updatedData)
    );
  };

  useEffect(() => {
    initAuth();
  }, []);

  const clearAuth = () => setAuth(null);

  return (
    <RootContext.Provider
      value={{
        auth,
        setAuth,
        clearAuth,
        updateAuth,
      }}
    >
      {isReady ? children : null}
    </RootContext.Provider>
  );
};

export const useRoot = () => useContext(RootContext);

export default RootProvider;
